import React from 'react'
import { Box, Typography } from '@mui/material'

const ImageTextSection = ({ imagePath }) => {
  return (
    <Box
      sx={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        padding: 4,
      }}>
      {/*Image Section */}
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}>
        <img
          src={imagePath}
          alt='Dashboard Illustration'
          style={{ width: '80%', height: 'auto' }}
        />
      </Box>

      {/*Text Section */}
      <Box sx={{ textAlign: 'left', paddingBottom: 2 }}>
        <Typography variant='caption' sx={{ fontWeight: 'bold' }}>
          Powered By:
        </Typography>
        <Typography variant='body2' sx={{ fontWeight: 'bold' }}>
          <span style={{ color: 'blue' }}>SUM IT</span> Consultancy Services
          Private Limited
        </Typography>
      </Box>
    </Box>
  )
}

export default ImageTextSection
